import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import FavoriteButton from './FavoriteButton'
import { getFavoriteSkus } from '../selectors'
import { addFavorite, removeFavorite } from '../actions'
import FavoriteLinkButton from './FavoriteLinkButton'
import { FAVORITE_LINK_ID, FAVORITE_LINK_HEART_ID } from '../constants'


const mapStateToProps = (state, { skuId }) => {
  const favoriteSkus = getFavoriteSkus(state)

  return {
    isFavorite: favoriteSkus.includes(skuId)
  }
}

const withClickHandler = withHandlers({
  handleClick: ({ isFavorite, addFavorite, removeFavorite, onBeforeRemoveFavorite, ...data }) => (event) => {
    const isFavoriteLink = event.currentTarget.id === FAVORITE_LINK_ID
    const imgEl = document.getElementById(FAVORITE_LINK_HEART_ID)

    if (isFavorite) {
      onBeforeRemoveFavorite && onBeforeRemoveFavorite()
      removeFavorite(data)

      if (isFavoriteLink) {
        imgEl.classList.remove('scale-in-out')
      }
    } else {
      addFavorite(data)

      if (isFavoriteLink) {
        setTimeout(() => {
          imgEl.classList.add('scale-in-out')
        }, 500)
      }
    }
  }
})

export default compose(
  connect(mapStateToProps, { addFavorite, removeFavorite }),
  withClickHandler
)(FavoriteButton)

export const FavoriteLink = compose(
  connect(mapStateToProps, { addFavorite, removeFavorite }),
  withClickHandler
)(FavoriteLinkButton)

